import { isCustomValue } from "../../utils/resolve-value.mjs";
import { isMotionValue } from "./is-motion-value.mjs";
function resolveMotionValue(value) {
  const unwrappedValue = isMotionValue(value) ? value.get() : value;
  return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}
export {
  resolveMotionValue
};
